const CONFIG = {
  baseURL: "https://fakestoreapi.com",
}

export default CONFIG;
